import { useState } from "react";

import { InformationIcon, SectionHeader } from "~/common/components";
import { FunctionalDomainsModal } from "./FunctionalDomainsModal";

export const FunctionalDomainsTitle = () => {
  const [showInfoModal, setShowInfoModal] = useState(false);

  return (
    <>
      <FunctionalDomainsModal
        show={showInfoModal}
        onClose={() => setShowInfoModal(false)}
      />
      <div className="flex items-center gap-2">
        <SectionHeader>Functional domains</SectionHeader>
        <button onClick={() => setShowInfoModal(true)}>
          <InformationIcon className="size-4 text-gray-20" />
        </button>
      </div>
    </>
  );
};
